import { initMenu } from "./_menu";

document.addEventListener("DOMContentLoaded", () => {
    initMenu();
});